import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { content } from "@/i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem("yc-lang");
      return ["ar", "fr", "en"].includes(stored) ? stored : "ar";
    } catch {
      return "ar";
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = lang === "ar" ? "rtl" : "ltr";
    try {
      localStorage.setItem("yc-lang", lang);
    } catch {
      /* private mode */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      dir: lang === "ar" ? "rtl" : "ltr",
      isAr: lang === "ar",
      setLang,
      toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
      t: content[lang],
    }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
